<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/jumbotron.html" name="c-gp-jumbotron">
<link rel="ractive" href="../components/sponsorship.html" name="c-gp-sponsorship">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-globalping-bg"></c-gp-header>

	<div class="p-globalping-credits">
		<c-gp-jumbotron className="credits" gridType="type4"></c-gp-jumbotron>

		<div class="gp-credits">
			<div class="gp-credits_info">
				<h1 class="gp-credits_info_title">Globalping limits and credits</h1>

				<div class="gp-credits_info_descr">
					Start using Globalping for free - no registration needed!
				</div>

				<div class="gp-credits_info_user-benefits">
					<div class="gp-credits_info_user-benefits_block">
						<span class="gp-credits_info_user-benefits_block_title">Unregistered User</span>

						<div class="gp-credits_info_user-benefits_block_list">
							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/check.svg"
									loading="lazy">

								<span class="gp-credits_info_user-benefits_block_list_item_numbers">
									{{this.userBenefits.unregistered.probesPerMeas}}
								</span>

								<span class="gp-credits_info_user-benefits_block_list_item_text">Probes per measurement</span>
							</span>

							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/check.svg"
									loading="lazy">

								<span class="gp-credits_info_user-benefits_block_list_item_numbers">
									{{this.userBenefits.unregistered.freeTestsPerHour}}
								</span>

								<span class="gp-credits_info_user-benefits_block_list_item_text">Free tests per hour</span>
							</span>
						</div>

						<span class="gp-credits_info_user-benefits_block_hint">
							<span>Higher limits for members!</span>
							<img as-tooltip="[ 'By creating a free account you help us fight abuse while getting access to higher limits and additional features.' ], 'top', undefined, undefined, 'multiline gp-credits_tooltip'"
								width="14"
								height="14"
								src="{{@shared.assetsHost}}/img/help-icon.svg">
						</span>
					</div>

					<div class="gp-credits_info_user-benefits_block registered">
						<span class="gp-credits_info_user-benefits_block_title">Registered User</span>
						<div class="gp-credits_info_user-benefits_block_list">
							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/check.svg"
									loading="lazy">
								<span class="gp-credits_info_user-benefits_block_list_item_numbers">{{this.userBenefits.registered.probesPerMeas}}</span>
								<span class="gp-credits_info_user-benefits_block_list_item_text">Probes per measurement</span>
							</span>

							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/check.svg"
									loading="lazy">
								<span class="gp-credits_info_user-benefits_block_list_item_numbers">{{this.userBenefits.registered.freeTestsPerHour}}</span>
								<span class="gp-credits_info_user-benefits_block_list_item_text">Free tests per hour</span>
							</span>

							<span class="gp-credits_info_user-benefits_block_list_item">
								<img width="20"
									height="20"
									src="{{@shared.assetsHost}}/img/check.svg"
									loading="lazy">
								<span class="gp-credits_info_user-benefits_block_list_item_text">Spend credits for extra tests</span>
							</span>
						</div>
					</div>
				</div>

				<div class="gp-credits_info_extra-tests">
					<img width="56" height="56" src="{{@shared.assetsHost}}/img/bulb-icon.svg">
					<div class="gp-credits_info_extra-tests_text">
						Registered users may run additional tests by spending credits.
						Each test above the free limit costs one credit.
					</div>
				</div>
			</div>

			<div class="gp-credits_become-a-sponsor">
				<h2 class="gp-credits_become-a-sponsor_title">Become a sponsor</h2>

				<p class="gp-credits_become-a-sponsor_descr">
					Get extra credits for your support!
					Sponsors get a base reward of 4000 credits per $1 donated, with a cumulative 5% bonus for each $100 donated in the past 12 months - up to 1500%.
				</p>

				<c-gp-sponsorship></c-gp-sponsorship>
			</div>

			<div class="gp-credits_host-a-probe">
				<img class="gp-credits_host-a-probe_polygons"
					width="362"
					height="288"
					src="{{@shared.assetsHost}}/img/credits/polygons_2.svg"
					loading="lazy">

				<div class="gp-credits_host-a-probe_block">
					<h2 class="gp-credits_host-a-probe_block_title">Host a probe</h2>

					<h3 class="gp-credits_host-a-probe_block_subtitle">+150 tests/probe/day</h3>

					<p class="gp-credits_host-a-probe_block_content">
						Generate free credits passively!
						Become a member of the community by hosting a probe and adopting it under your account.
						For each day your probe stays online, you will get additional free credits.
					</p>

					<a class="gp_btn_green gp-credits_host-a-probe_block_btn"
						on-click="@this.openLink(@shared.serverHost + '/#join-the-network')">
						Host a probe
					</a>
				</div>
			</div>

			<div class="gp-credits_faq">
				<h2 class="gp-credits_faq_title">Frequently Asked Questions</h2>
				<span class="gp-credits_faq_descr"></span>

				<div class="gp-credits_faq_list">
					{{#each faq}}
						<div class="gp-credits_faq_list_item">
							<span class="gp-credits_faq_list_item_question">{{this.question}}</span>
							<span class="gp-credits_faq_list_item_answer">{{{this.answer}}}</span>
						</div>
					{{/each}}
				</div>
			</div>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const tooltip = require('../../assets/js/decorators/tooltip');

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				title: 'Credits - Globalping',
				description: 'Start using Globalping for free - no registration needed! Get higher limits by creating an account, hosting probes, or sponsoring the project.',
				userBenefits: {
					unregistered: {
						probesPerMeas: 50,
						freeTestsPerHour: 250,
					},
					registered: {
						probesPerMeas: 500,
						freeTestsPerHour: 500,
					},
				},
				faq: [
					{
						question: 'How to generate free credits?',
						answer: 'Simply log in to the <a href="https://dash.globalping.io" target="_blank">Globalping Dashboard</a> and follow the instructions. You will need to host a probe using a Docker container or by ordering our hardware probe.',
					},
					{
						question: 'What is a credit and what does it do?',
						answer: 'A single credit equals one test. For example if you request a ping measurement from 5 locations, it will use 5 credits. A single measurement can request up to 500 probes, which effectively means a maximum of 500 credits being used per measurement.',
					},
					{
						question: 'How to buy more credits?',
						answer: 'You will need to register an account first and then donate your chosen amount using GitHub Sponsors. Our system will pick up the donation and credit your account automatically.',
					},
					{
						question: 'Can I use credits to power a commercial tool or product?',
						answer: 'Yes, we support commercial use of Globalping within the limits of our terms of service.',
					},
					{
						question: 'Do you support non-profits with free credits?',
						answer: 'Yes, we can provide large amounts of free credits to all kinds of organizations and projects after a manual review. Please contact us via email.',
					},
					{
						question: 'How to get in contact?',
						answer: 'To report issues with the API or our tools it is best to open a GitHub issue. But if for any reason you prefer to contact us privately via email you can do so at <a href="mailto:d@globalping.io">d@globalping.io</a>',
					},
				],
			};
		},
		openLink (url) {
			event.preventDefault();
			window.open(url, '_blank');
		},
	};
</script>
